var Handlebars = require("../../../../handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, alias2=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a href=\"#\">\n  <img alt=\""
    + alias1(__default(require("../../../../../src/helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Trying to download thumbnail",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":2,"column":12},"end":{"line":2,"column":49}}}))
    + "\">\n</a>\n<div>"
    + alias1(alias2((depth0 != null ? lookupProperty(depth0,"date") : depth0), depth0))
    + "<br/>"
    + alias1(alias2((depth0 != null ? lookupProperty(depth0,"time") : depth0), depth0))
    + "</div>\n<button class=\"btn btn-default btn-xs record-info\">\n  <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n</button>\n<button class=\"btn btn-default btn-xs record-unselect\">\n  <i class=\"fa fa-minus-circle\" aria-hidden=\"true\"></i>\n</button>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /~/eoxc/src/download/views/SelectionListItemView.hbs
// module id = 2045
// module chunks = 0